import Repository from "./Repository";

export default {
  getCoinsStats(payload) {
    return Repository.get(
      `/get-transactions?userId=${payload}&startDate=${""}&endDate=${""}`
    );
  },
  getCoinsLimit() {
    const year = new Date().getFullYear();
    return Repository.get(`/check-disbursement-limit/${year}`);
  },
};
